import reducer from './store'

export default reducer
